import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

interface LoadingContextType {
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

interface LoadingProviderProps {
    children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => { 
    const [isLoading, setIsLoading] = useState(false);
    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    return (
        <LoadingContext.Provider value={{ isLoading, setLoading }}>
            {isLoading && <LoadingSpinner />}
            <div className={isLoading ? 'hidden' : ''}>
                {children}
            </div>
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
